document.addEventListener("DOMContentLoaded", function () {
    const toggleSwitch = document.getElementById("toggleSwitch");
    const demoForm = document.getElementById("demoForm");
    const accessForm = document.getElementById("accessForm");
    const demoLabel = document.querySelector(".demo-label");
    const accessLabel = document.querySelector(".access-label");

    // Ensure default state
    demoForm.style.display = "flex";
    accessForm.style.display = "none";
    demoLabel.style.color = "white";
    accessLabel.style.color = "gray";

    toggleSwitch.addEventListener("change", function () {
        if (toggleSwitch.checked) {
            demoForm.style.display = "none";
            accessForm.style.display = "flex";
            demoLabel.style.color = "gray";
            accessLabel.style.color = "white";
        } else {
            demoForm.style.display = "flex";
            accessForm.style.display = "none";
            demoLabel.style.color = "white";
            accessLabel.style.color = "gray";
        }
    });
});
